module.exports = __webpack_public_path__ + "static/media/JestIcon.1cc3be16.svg";